<template>
    <div v-if="category" :data-testid="`category-pill-${category}`" :class="{'category-pill': true, selected: selected}">
        <button @click="emit('click')">
            <span>{{ category }}</span>
        </button>
    </div>
</template>

<script lang="ts" setup>
    const emit = defineEmits<{
        (e: 'click'): void;
    }>();

    const props = defineProps<{
        category: string;
        selected?: boolean;
    }>();
</script>

<style lang="scss">
    .category-pill {
        padding: var(--joy-core-spacing-1) var(--joy-core-spacing-3);

        a,
        button {
            display: inline-block;
            color: var(--joy-color-primary-50);
            font-size: var(--joy-font-size-primary-400);

            text-align: center;

            transition: color var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            position: relative;

            background: transparent;
            span {
                position: relative;
                z-index: 2;
            }
            &::after {
                border: 1px solid var(--joy-color-primary-50);
                border-radius: 50px;

                background-color: var(--joy-color-neutral-0);
                content: '';
                z-index: 1;
                position: absolute;
                top: -4px;
                bottom: -4px;
                right: -12px;
                left: -12px;
                transition: background-color var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            }
            &:hover {
                color: var(--joy-color-neutral-0);
                &::after {
                    background-color: var(--joy-color-primary-50);
                }
            }
        }

        &.selected {
            a,
            button {
                color: var(--joy-color-neutral-0);
                &::after {
                    background-color: var(--joy-color-primary-50);
                }
                &:hover::after {
                    background-color: var(--joy-color-primary-70);
                }
            }
        }
    }
</style>
